import React, { useState } from 'react';
import wnslogo from "../../assets/images/logowhite.svg";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useNavigate } from 'react-router-dom';
import { MDBSwitch } from 'mdb-react-ui-kit';



const Header = (props) =>{

    const user = sessionStorage.getItem('user');
    const [modalShow, setModalShow] = useState(false);
    const navigate = useNavigate();
    const  {toggle, setToggle}=props;

    const filtertoggle = () => {
      setToggle(!toggle)
    }
    const logout =()=>{
      localStorage.removeItem('login', 'true');
      navigate('/')
    }
    return(


<header>
  <nav className="navbar navbar-expand-lg">
    <div className="container-fluid">
      <button className="navbar-toggler" type="button" data-mdb-toggle="collapse"
        data-mdb-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <i className="fas fa-bars"></i>
      </button>

      <div className="" id="navbarSupportedContent">
        <a className="navbar-brand mt-2 mt-lg-0" href="#">
          <img src={wnslogo}  height="20px" alt="WNS Logo"
            loading="lazy" />
        </a>
      </div>

      <div className="d-flex align-items-center">


      <OverlayTrigger
          key="bottom"
          placement="bottom"
          overlay={
            <Tooltip className="primary " id={`tooltip-bottom`}>
              Logout
            </Tooltip>
          }
        >
        <Button variant="primary br-3 br-5 mx-3" onClick={logout}>
          <FontAwesomeIcon icon={faSignOutAlt}  className="fa-2x" />
        </Button>
      </OverlayTrigger>
    
      </div>
    </div>
  </nav>
    
</header>
    
    )
}
export default Header;